import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// initial state
const state: webpartv3.state.WebpartsState = {   
    infoMounted: false,
    unreadMails: [],
    unreadMailCount: 0,

    calendarFolders: [],
    dailyEvents: [],
    todayEvents: [],
    monthlyEvents: [],
}

export default {
    state,
    actions,
    getters,
    mutations,
}
